import React from 'react'
import { Trans } from '@lingui/macro'
import { ButtonPrimary } from 'front-end/src/components'
import { useMutation } from '@apollo/client'
import { ITopicEnrolment } from '../../../../../types/ITopicEnrolment'
import { AssignTopicsDocument } from './ResourceAssignmentButton.codegen'
import { omit } from 'lodash'

export function ResourceAssignmentButton(props: {
  topicIds: number[]
  userIds: number[]
  groupIds: number[]
  workspaceId: number
  targetCompletionDate?: Date | null
  customEmailBody?: string
  forceNewEnrolment: boolean
  emailIdentityId: number | null
  sendEmail?: boolean
  onShared: (userEnrolments: ITopicEnrolment[][]) => void
}) {
  const [assign, { loading }] = useMutation(AssignTopicsDocument, {
    variables: {
      workspaceId: props.workspaceId,
      input: { ...omit(props, ['workspaceId']) }
    }
  })

  return (
    <ButtonPrimary
      key="assign"
      onClick={async () => {
        const res = await assign()
        props.onShared(res.data.workspace.assignTopics)
      }}
      isLoading={loading}
    >
      <Trans>Share</Trans>
    </ButtonPrimary>
  )
}
